import { Route } from '@angular/router'
import { publicGuard } from '@baboor/baboor-auth'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type PublicRoutes = {
    landing: Route
    pricing: Route
    downloadApp: Route
    aboutUs: Route
    contactUs: Route
}

export const publicRoutes: PublicRoutes = {
    landing: {
        path: '',
        loadComponent: () =>
            import('../page-landing/page-landing.component').then(
                (m) => m.PageLandingComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
        pathMatch: 'full',
        canActivate: [publicGuard()],
        data: {
            title: 'Hair Style Club',
        },
    },
    pricing: {
        path: 'pricing',
        loadComponent: () =>
            import('../page-pricing/page-pricing.component').then(
                (m) => m.PagePricingComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
        data: {
            title: 'Pricing - Hair Style Club',
        },
    },
    downloadApp: {
        path: 'download-app',
        loadComponent: () =>
            import('../page-download/page-download.component').then(
                (m) => m.PageDownloadComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
        data: {
            title: 'Download App - Hair Style Club',
        },
    },
    aboutUs: {
        path: 'about-us',
        loadComponent: () =>
            import('../page-about-us/page-about-us.component').then(
                (m) => m.PageAboutUsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
    },
    contactUs: {
        path: 'contact-us',
        loadComponent: () =>
            import('../page-contact-us/page-contact-us.component').then(
                (m) => m.PageContactUsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
    },
}
